(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["klaviyo-back-in-stock"] && !Shopify.designMode) return;
  try {
    class KlaviyoBackInStock extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.init()
    }

    init() {
      this.form = this.querySelector('form')
      this.button = this.querySelector('button')
      this.emailInput = this.querySelector('[name="email"]')
      this.successMessage = this.querySelector('.js-success-message')
      this.companyId = this.querySelector('[name="company_id"]')?.value || null;

      if( this.companyId === null ) {
        console.error('missing company id');
        return
      }

      this.form.addEventListener('submit', async (event) => {
        event.preventDefault()
        event.stopPropagation();

        this.button.classList.add('loading')
        this.emailInput.setAttribute('disabled', true)

        this.querySelector('.button__icon__svg').classList.add('hidden')
        this.querySelector('.loading__spinner').classList.remove('hidden')

        const email = this.emailInput.value.trim()
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

        if (!emailRegex.test(email)) {
          this.emailInput.setCustomValidity('Please enter a valid email address')
          this.emailInput.reportValidity()
          return
        }

        this.emailInput.setCustomValidity('')

        const variantId = this.form.querySelector('input[name="variant_id"]').value
        const options = {
          method: 'POST',
          headers: {
            accept: 'application/json',
            revision: '2024-06-15',
            'content-type': 'application/json',
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: `${email}`,
                    },
                  },
                },
                channels: ['EMAIL'],
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${variantId}`,
                  },
                },
              },
            },
          }),
        }

        const response = await fetch(
          `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.companyId}`,
          options,
        )
        if (response) {
          this.successMessage.classList.remove('visually-hidden')
          this.form.classList.add('visually-hidden');
          // setTimeout(function(){
          //   this.successMessage.classList.add('visually-hidden')
          //   this.form.classList.remove('visually-hidden');
          // }, 3000)
        }
        this.button.classList.remove('loading')
        this.emailInput.removeAttribute('disabled')
        this.querySelector('.button__icon__svg').classList.remove('hidden')
        this.querySelector('.loading__spinner').classList.add('hidden')
      })

      // Add input validation on email changes
      this.emailInput.addEventListener('input', () => {
        const email = this.emailInput.value.trim()
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

        if (!emailRegex.test(email)) {
          this.button.setAttribute('disabled', true)
          this.emailInput.setCustomValidity('Please enter a valid email address')
        } else {
          this.button.removeAttribute('disabled')
          this.emailInput.setCustomValidity('')
        }
      })
    }
  }

  if (!customElements.get('klaviyo-back-in-stock')) {
    customElements.define('klaviyo-back-in-stock', KlaviyoBackInStock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sorting-chips"] && !Shopify.designMode) return;
  try {
    class SortingChips extends HTMLElement {
    connectedCallback() {
      this.pill = this.querySelector('.sorting-chips__pill');
      this.reposition = this.reposition.bind(this);

      // Safari applies a focus ring to radios on mouse/tap selection — the
      // stray "extra circle". Blur after pointer-driven changes only;
      // keyboard users keep their visible focus ring (accessibility rule).
      this.addEventListener('pointerdown', () => {
        this.viaPointer = true;
      });

      this.addEventListener('change', (event) => {
        if (this.viaPointer && event.target instanceof HTMLElement) {
          event.target.blur();
          this.viaPointer = false;
        }
        this.reposition();
        // facets forms don't auto-submit on change — the old sorting component
        // called updateFilters() explicitly, so we do the same
        const facetsForm = this.closest('facets-form-component');
        if (facetsForm && typeof facetsForm.updateFilters === 'function') {
          facetsForm.updateFilters();
        }
      });

      // When the section re-renders after sorting, the morph updates the
      // checked attribute on the (possibly reused) element without firing a
      // change event — watch for it so the pill glides instead of sticking.
      this.checkedObserver = new MutationObserver(this.reposition);
      this.checkedObserver.observe(this, { subtree: true, attributes: true, attributeFilter: ['checked'] });

      window.addEventListener('resize', this.reposition);
      requestAnimationFrame(() => {
        this.reposition();
        // enable the slide transition only after the initial placement
        requestAnimationFrame(() => this.classList.add('is-ready'));
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.reposition);
      if (this.checkedObserver) this.checkedObserver.disconnect();
    }

    reposition() {
      const checked = this.querySelector('input:checked');
      const chip = checked && checked.closest('label');
      if (!chip || !this.pill) return;
      this.pill.style.width = chip.offsetWidth + 'px';
      this.pill.style.transform = 'translateX(' + chip.offsetLeft + 'px)';
    }
  }

  if (!customElements.get('sorting-chips')) {
    customElements.define('sorting-chips', SortingChips);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sorting-control"] && !Shopify.designMode) return;
  try {
    class SortingControl extends HTMLElement {
    connectedCallback() {
      // Event DELEGATION on the custom element itself: the section morph
      // after sorting can replace the inner trigger/rows, which silently
      // dropped listeners attached to those nodes (the "sort won't reopen
      // after selecting" bug). Listeners on `this` survive the morph, and
      // every lookup below queries fresh nodes at use time.
      this.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const option = target.closest('[data-sort-option]');
        if (option) {
          this.select(option.dataset.value);
          return;
        }
        if (target.closest('[data-panel-trigger]')) this.toggle();
      });

      // pointerdown (not click) so a tap anywhere on the page backs out of
      // the popover reliably on touch devices, even mid-scroll
      this.outsideHandler = (event) => {
        if (!this.isOpen()) return;
        if (event.target instanceof Node && this.contains(event.target)) return;
        this.toggle(false);
      };
      document.addEventListener('pointerdown', this.outsideHandler);

      this.escHandler = (event) => {
        if (event.key === 'Escape' && this.isOpen()) {
          this.toggle(false);
          const trigger = this.querySelector('[data-panel-trigger]');
          if (trigger) trigger.focus();
        }
      };
      document.addEventListener('keydown', this.escHandler);
    }

    disconnectedCallback() {
      document.removeEventListener('pointerdown', this.outsideHandler);
      document.removeEventListener('keydown', this.escHandler);
    }

    isOpen() {
      const panel = this.querySelector('[data-panel]');
      return !!panel && panel.classList.contains('is-open');
    }

    toggle(force) {
      const panel = this.querySelector('[data-panel]');
      if (!panel) return;
      const open = typeof force === 'boolean' ? force : !panel.classList.contains('is-open');
      panel.classList.toggle('is-open', open);
      const trigger = this.querySelector('[data-panel-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', String(open));
    }

    select(value) {
      const options = [...this.querySelectorAll('[data-sort-option]')];
      const chosen = options.find((b) => b.dataset.value === value);
      if (!chosen) return;

      options.forEach((b) => b.setAttribute('aria-selected', String(b === chosen)));
      const triggerValue = this.querySelector('.sorting-control__trigger-value');
      if (triggerValue) triggerValue.textContent = chosen.textContent.trim();
      this.toggle(false);

      const input = this.querySelector('[data-sort-input]');
      if (input && input.value !== value) {
        input.value = value;
        const facetsForm = this.closest('facets-form-component');
        if (facetsForm && typeof facetsForm.updateFilters === 'function') {
          facetsForm.updateFilters();
        }
      }
    }
  }

  if (!customElements.get('sorting-control')) {
    customElements.define('sorting-control', SortingControl);
  }
  } catch(e) { console.error(e); }
})();

})();
